import { AppliedPoint, DiscountAmount, DiscountPrice } from '@/models/discount-amount/discount-amount'
import { Order } from '@spa/store/modules/orderHistory/types'

export function convertFromStoreOrderHistoryToDiscountAmount(order: Order): DiscountAmount {
  const discountPrice = order.discount ?
    DiscountPrice.valueOf(order.discount.amount) :
    DiscountPrice.zero()
  const appliedPoint = order.payment.point ?
    AppliedPoint.valueOf(order.payment.point.amount) :
    AppliedPoint.zero()

  return new DiscountAmount(discountPrice, appliedPoint)
}
